import { render, staticRenderFns } from "./LinkFields.vue?vue&type=template&id=39be1ee8&"
import script from "./LinkFields.vue?vue&type=script&lang=js&"
export * from "./LinkFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports